import { cva } from '@/styled-system/css';

export const buttonIconRecipe = cva({
  base: {
    transition: {
      _motionReduce: 'none',
      _motionSafe: '200ms ease color',
    },
  },
  variants: {
    tone: {
      'brand': {},
      'neutral': {},
      'neutral-fixed': {},
      'critical': {},
    },
    emphasis: {
      filled: {},
      outlined: {},
      bare: {},
    },
    disabled: {
      true: {},
      false: {},
    },
    onImpact: {
      true: {},
      false: {},
    },
    loading: {
      true: {
        color: 'transparent.invisible',
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      emphasis: 'filled',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'Button.filled.brand.label.default',
        },
      },
    },
    {
      emphasis: 'filled',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'Button.filled.critical.label.default',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'Button.outlined.brand.label.default',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'neutral',
      loading: false,
      css: {
        color: {
          base: 'Button.outlined.neutral.label.default',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'Button.outlined.critical.label.default',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'Button.outlined.neutral-fixed.label.default',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'icon.action.hero.default',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'icon.action.critical.hero.default',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'neutral',
      loading: false,
      css: {
        color: {
          base: 'icon.neutral',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'icon.action.neutral-fixed.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'Button.onImpact.filled.brand.label.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'neutral',
      loading: false,
      css: {
        color: {
          base: 'Button.onImpact.outlined.neutral.label.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'Button.onImpact.outlined.brand.label.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'Button.onImpact.outlined.critical.label.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'Button.onImpact.filled.critical.label.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'Button.onImpact.filled.neutral-fixed.label.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'Button.onImpact.outlined.neutral-fixed.label.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'icon.onImpact.action.hero.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'icon.onImpact.action.critical.hero.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'neutral',
      loading: false,
      css: {
        color: {
          base: 'icon.onImpact.neutral',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'icon.onImpact.neutral-fixed',
        },
      },
    },
    {
      emphasis: 'filled',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.filled.brand.label.hover',
          _groupActive: 'Button.filled.brand.label.pressed',
        },
      },
    },
    {
      emphasis: 'filled',
      tone: 'critical',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.filled.critical.label.hover',
          _groupActive: 'Button.filled.critical.label.pressed',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.outlined.brand.label.hover',
          _groupActive: 'Button.outlined.brand.label.pressed',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'neutral',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.outlined.neutral.label.hover',
          _groupActive: 'Button.outlined.neutral.label.pressed',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'critical',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.outlined.critical.label.hover',
          _groupActive: 'Button.outlined.critical.label.pressed',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'neutral-fixed',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.outlined.neutral-fixed.label.hover',
          _groupActive: 'Button.outlined.neutral-fixed.label.pressed',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'icon.accent.blue.strong-fixed',
          _groupActive: 'icon.accent.blue.strong-fixed',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'critical',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'icon.action.critical.hero.hover',
          _groupActive: 'icon.action.critical.hero.pressed',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'neutral',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'icon.neutral-fixed',
          _groupActive: 'icon.neutral-fixed',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'neutral-fixed',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'icon.action.neutral-fixed.hover',
          _groupActive: 'icon.action.neutral-fixed.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.onImpact.filled.brand.label.hover',
          _groupActive: 'Button.onImpact.filled.brand.label.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'neutral',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.onImpact.outlined.neutral.label.hover',
          _groupActive: 'Button.onImpact.outlined.neutral.label.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'critical',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.onImpact.outlined.critical.label.hover',
          _groupActive: 'Button.onImpact.outlined.critical.label.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.onImpact.outlined.brand.label.hover',
          _groupActive: 'Button.onImpact.outlined.brand.label.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'critical',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.onImpact.filled.critical.label.hover',
          _groupActive: 'Button.onImpact.filled.critical.label.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'critical',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.onImpact.outlined.critical.label.hover',
          _groupActive: 'Button.onImpact.outlined.critical.label.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'neutral-fixed',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.onImpact.filled.neutral-fixed.label.hover',
          _groupActive: 'Button.onImpact.filled.neutral-fixed.label.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'neutral-fixed',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.onImpact.outlined.neutral-fixed.label.hover',
          _groupActive: 'Button.onImpact.outlined.neutral-fixed.label.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'icon.action.hero.hover',
          _groupActive: 'icon.action.hero.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'critical',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'icon.action.critical.hero.hover',
          _groupActive: 'icon.action.critical.hero.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'neutral',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'icon.neutral',
          _groupActive: 'icon.neutral',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'neutral-fixed',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'icon.neutral-fixed',
          _groupActive: 'icon.neutral-fixed',
        },
      },
    },
  ],
});
